module.exports = __webpack_public_path__ + "img/cuxiaotaocan@2x.png?v=f5de7142";